import { Command } from 'commander';
import type { BrandConfig } from '../branding/types';
import { loadConfig } from '../config/loader';
import { Shuttle } from '../core/shuttle';
import { resolveProfile, runConfigSearchPaths } from '../branding/apply';
import { setupShutdownHandler } from '../lifecycle/shutdown';

export function buildRunCommand(brand: BrandConfig): Command {
  return new Command('run')
    .description(`Start the ${brand.product.title} subscribe loop`)
    .option('--config <path>', 'Path to shuttle.yaml config file')
    .option('-p, --profile <name>', 'Config profile to run (isolates pairing/config; default "default")')
    .action(async (options: { config?: string; profile?: string }) => {
      try {
        const profile = resolveProfile(brand, options.profile);
        const config = loadConfig({
          explicitPath: options.config,
          searchPaths: runConfigSearchPaths(brand, profile),
          productId: brand.product.id,
        });
        const shuttle = new Shuttle({ brand, config, profile });
        await shuttle.start();
        setupShutdownHandler(() => shuttle.stop());
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        console.error(`Error: ${message}`);
        process.exit(1);
      }
    });
}
